<template>
    <div :class="isExpanded ? 'active_card' : 'card_container'">
        <van-row>
            <van-col span="20">
                <div class="title" :style="{ color: isExpanded ? '#FDAC50' : '' }">{{$t( props.title || '') }}</div>
                <div class="create_time">{{ messageData.createTime }}</div>
            </van-col>
            <van-col span="4" class="icon_container">
                <div v-if="isExpanded" class="active_collapse_icon"><img src="@/assets/common/message_arrow_up.png"
                        alt="" @click="toggleExpand">
                </div>
                <div v-else class="collapse_icon"><img src="@/assets/common/message_arrow_down.png" alt=""
                        @click="toggleExpand">
                </div>
            </van-col>
        </van-row>
        <div class="msg_content" :class="{ collapsed: !isExpanded }">
            {{ displayedMessage }}
        </div>
        <div v-if="isExpanded">
            <img :src="attachement" width="30%" alt="">
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, defineProps } from 'vue'
const isExpanded = ref(false)
interface MessageData {
    content: string
    createTime: string
}

const props = defineProps<{
    messageData: MessageData
    title?: string
    attachement?: string
}>()
const fullMessage = ref(props.messageData.content)

const displayedMessage = computed(() =>
    isExpanded.value ? fullMessage : fullMessage.value.split('\n')[0]
)

const toggleExpand = () => {
    isExpanded.value = !isExpanded.value
}

</script>
<style scoped>
.card_container {
    background: #3D2E22;
    border: 0.5px solid rgba(138, 153, 152, 0.25);
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
}

.active_card {
    background: #3D2E22;
    border: 0.5px solid rgba(221, 122, 51, 1);
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
}

.collapse_icon {
    background: rgba(255, 255, 255, 0.20);
    width: 15px;
    border-radius: 30px;
    padding: 2px;
    height: 15px;
}

.collapse_icon img {
    width: 15px;
}

.active_collapse_icon {
    background: #FDAC50;
    ;
    width: 15px;
    border-radius: 30px;
    padding: 2px;
    height: 15px;
}

.active_collapse_icon img {
    width: 15px;
}

.icon_container {
    display: flex;
    justify-content: right;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
}

.create_time {
    color: rgba(255, 255, 255, 0.45);
    font-size: 13px;
    padding: 10px 0;
}

.msg_content {
    color: white;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
}

.msg_content.collapsed {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>